export class Environment {
    // Detects if device is on iOS
    // Detects if device is in standalone mode
    static isIos() {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
    }
    static isInStandaloneMode() {
        return ('standalone' in window.navigator) && (window.navigator.standalone);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/lib/environment.ts
// module id = 122
// module chunks = 1